module.exports = __webpack_public_path__ + "static/media/Opal.4a4a75f8.mp4";